import { render, staticRenderFns } from "./V2LessonCard.vue?vue&type=template&id=08547704&scoped=true&"
import script from "./V2LessonCard.vue?vue&type=script&lang=js&"
export * from "./V2LessonCard.vue?vue&type=script&lang=js&"
import style0 from "./V2LessonCard.vue?vue&type=style&index=0&id=08547704&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08547704",
  null
  
)

export default component.exports